// extracted by mini-css-extract-plugin
export default {"root":"HomepageHero_root__dPjNk","desktop":"HomepageHero_desktop__3rCO2","mobile":"HomepageHero_mobile__HEw_m","tablet":"HomepageHero_tablet__RB9kJ"};